import { useEffect, useRef, useState } from "react";
import Blocks from "../blocks";
import GroupDiscussion from "../../assets/images/group-discussion.png";
import Partials from "../partials";
import { toast } from "react-toastify";
import parsePhoneNumber from "libphonenumber-js";
import { useLocation, useParams } from "react-router-dom";
import { useQuery, useQueryClient } from "react-query";
import { getAllStudentsOfVirtualClass } from "../../api/students";
import moment from "moment";
import { getClassDetailsById } from "../../utils/reactQueries";
import { IoMdArrowBack } from "react-icons/io";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const PageAddStudentToClass = () => {
  const addStudentCompRef = useRef();
  const [studentDataFromFile, _setStudentDataFromFile] = useState([]);
  const [edit, setEdit] = useState(false);
  const params = useParams();
  const history = useHistory();
  const classId = params.classId;
  const location = useLocation();
  const path = location.pathname.split("/");
  const queryClient = useQueryClient();
  const [isProcessing, setIsProcessing] = useState(false);
  const [progress, setProgress] = useState(0)
  
  useEffect(() => {
    if (path[3] === "edit-students") {
      setEdit(true);
    }
  }, []);

  useEffect(() => {
    queryClient.invalidateQueries("getAllStudentsOfVirtualClass");
  }, []);

  /** get students details */
  const getStudentDetails = (classId) => {
    return useQuery(
      ["getAllStudentsOfVirtualClass", classId],
      () => getAllStudentsOfVirtualClass(classId),
      {
        enabled: !!classId,
        staleTime: 180000,
        cacheTime: 600000,
      }
    );
  };

  const {
    status: isStatus,
    data,
    error,
    isFetching: fetchingStudentDetails,
  } = getStudentDetails(classId);

  useEffect(() => {
    if (
      !fetchingStudentDetails &&
      data?.data?.statusCode === 200 &&
      data?.data?.body?.length > 0
    ) {
      addStudentCompRef.current.setExcelData(data.data.body, true);
    }
  }, [data, fetchingStudentDetails]);

  /** get class details */
  const {
    status,
    data: classData,
    error: classError,
    isFetching,
  } = getClassDetailsById(classId);
  const _classData = classData?.data;

  const saveFileData = ({ rows, errors }) => {
  if (errors && errors.length > 0) {
    toast.error("The file has errors or could not be read.", { autoClose: 5000 });
    return;
  }
  if (!rows || !rows.length) {
    toast.error(
      "The file you uploaded might be empty or mismatching with our template. Please match your headers and values with our template.",
      { autoClose: 5000 }
    );
    return;
  }
  addStudentCompRef.current.setExcelData([], true);
  setIsProcessing(true);
  setProgress(0);

  const chunkSize = 50; // Process 50 students at a time. You can adjust this.
  let currentIndex = 0;

  function processChunk() {
    const chunk = rows.slice(currentIndex, currentIndex + chunkSize);
    if (chunk.length > 0) {
      const studentsChunk = chunk.map((row) => ({
        ...row,
        mobile_number: parsePhoneNumber(row.mobile_number)?.number || "",
      }));

      // Use the existing setExcelData to append the new chunk
      addStudentCompRef.current.setExcelData(studentsChunk);

      currentIndex += chunk.length;
      const currentProgress = Math.round((currentIndex / rows.length) * 100);
      setProgress(currentProgress);
      
      // Schedule the next chunk, giving the browser time to update the UI
      setTimeout(processChunk, 0);
    } else {
      // Done processing
      setIsProcessing(false);
      toast.success("All students have been loaded.");
    }
  }

  // Start the processing
  processChunk();
};

  const mapForExcelFile = {
    "First Name": "first_name",
    "Last Name": "last_name",
    "Mobile Number": "mobile_number",
    Email: "email",
  };

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <div className={"page PageAddStudentToClass"}>
      <div className="container mx-auto">
        <h3
          className={
            "flex items-center justify-center gap-2 lg:hidden text-xl text-center pt-16 pb-4 font-['Poppins-Bold']"
          }
        >
          <IoMdArrowBack
            size={20}
            className="cursor-pointer"
            onClick={() => handleGoBack()}
          />
          {edit ? "Edit students for the class" : "Add Students for the class"}
        </h3>
        <ul
          className={
            "flex lg:hidden flex-wrap items-center justify-center gap-4 md:gap-8 mb-6 md:mb-14"
          }
        >
          <li className={"flex items-center"}>
            <span className="icon icon-book-open text-gray-500 mr-2 text-lg"></span>
            <p className="break-all">{_classData?.title}</p>
          </li>
          <li className={"flex items-center"}>
            <span className="icon icon-calendar text-gray-500 mr-2 text-lg"></span>
            <p>{moment.unix(_classData?.start_time).format("MM-DD-YYYY")}</p>
          </li>
          <li className={"flex items-center"}>
            <span className="icon icon-clock text-gray-500 mr-2 text-lg"></span>
            <p>
              {moment.unix(_classData?.start_time).format("HH:mmA")}-
              {moment
                .unix(_classData?.start_time + _classData?.duration_seconds)
                .format("HH:mmA")}
            </p>
          </li>
        </ul>
        <div className="flex flex-col lg:flex-row items-center">
          <div className="bgWrapper lg:flex justify-center items-center bg-white">
            <img src={GroupDiscussion} alt="" />
          </div>
          <div className="pageContent w-full max-w-3xl mx-auto md:mr-0 md:ml-auto  mb-4 bg-white p-4 rounded-xl">
            {isProcessing && (
              <div className="absolute inset-0 bg-white bg-opacity-90 flex flex-col justify-center items-center z-20 rounded-xl">
                <h3 className="text-xl font-bold mb-4">Processing Students...</h3>
                <div className="w-11/12 bg-gray-200 rounded-full">
                  <div
                    className="bg-black text-xs font-medium text-blue-100 text-center p-1 leading-none rounded-full"
                    style={{ width: `${progress}%` }}
                  >
                    {progress}%
                  </div>
                </div>
              </div>
            )}
            <h1
              className={
                "hidden items-center gap-2 lg:flex mb-4 text-4xl font-heading"
              }
            >
              <IoMdArrowBack
                size={40}
                className="cursor-pointer"
                onClick={() => handleGoBack()}
              />
              {edit
                ? "Edit students for the class"
                : "Add Students for the class"}
            </h1>
            <Blocks.ErrorBoundary>
              <ul
                className={
                  "hidden lg:flex flex-col md:flex-row gap-4 md:gap-8 mb-6 md:mb-14"
                }
              >
                <li className={"flex items-center"}>
                  <span className="icon icon-book-open text-gray-500 mr-2 text-lg"></span>
                  <p>{_classData?.title}</p>
                </li>
                <li className={"flex items-center"}>
                  <span className="icon icon-calendar text-gray-500 mr-2 text-lg"></span>
                  <p>
                    {moment.unix(_classData?.start_time).format("MM-DD-YYYY")}
                  </p>
                </li>
                <li className={"flex items-center"}>
                  <span className="icon icon-clock text-gray-500 mr-2 text-lg"></span>
                  <p>
                    {moment.unix(_classData?.start_time).format("HH:mmA")}-
                    {moment
                      .unix(
                        _classData?.start_time + _classData?.duration_seconds
                      )
                      .format("HH:mmA")}
                  </p>
                </li>
              </ul>

              <Blocks.BlockAddStudentsToClass
                ref={(ref) => (addStudentCompRef.current = ref)}
                initialData={studentDataFromFile}
                isEdit={edit}
              />

              <p className={" text-center text-2xl"}>or</p>

              <Partials.PartialImportExcel
                fileMapping={mapForExcelFile}
                onFileReadSuccess={saveFileData}
              />
            </Blocks.ErrorBoundary>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageAddStudentToClass;
